<template>
<v-form
ref="form"
v-model="valid"
lazy-validation>
  <v-container fluid class="px-2 forma-erp">
    <v-row no-gutters justify="center">
      <v-col cols="12" class="pa-0">

        <v-progress-circular v-if="this.saving"
          indeterminate
          color="green"
        ></v-progress-circular>

        <!-- Traka s nazivom dokumenta. Ispis i eRacun ovdje nemaju smisla jer se
             dokument tek stvara ili ispravlja - ostaje samo put na stavke. -->
        <div class="traka-ekrana mb-3">
          <span class="naslov">
            <span v-if="this.$store.state.editItem  === 0">
              {{langC.CreateNew}} {{ documentNameLoc }}
            </span>
            <span v-if="this.$store.state.editItem === 1">
              {{langC.Edit}} {{ documentNameLoc }} {{document.documentId}}
            </span>
          </span>
          <v-spacer></v-spacer>
          <v-btn small outlined color="primary" :disabled="!valid" @click="validate" title="Snimi dokument i otvori stavke">
            Stavke
          </v-btn>
        </div>

        <!-- DOKUMENT -->
        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">Dokument</v-card-title>
          <v-card-text class="pt-5 pb-1">
            <v-row dense>
              <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                <v-text-field outlined hide-details="auto" dense :label="lang.DocumentDate" ref="docdate" v-model="document.documentDate" type="date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                <v-text-field outlined hide-details="auto" dense :label="lang.documentTime" v-model="document.documentTime" type="time"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                <v-text-field outlined hide-details="auto" dense label="Br. dana" v-model="nrDays" type="number" min="1" max="365" step="1"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                <v-text-field outlined hide-details="auto" dense :label="lang.DeadLine" v-model="document.documentInvoiceEndDate" type="date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" class="pr-3" v-if="$store.state.documentActiv === 'InvoiceSales' ">
                <v-text-field outlined hide-details="auto" dense :label="lang.startPeriod" v-model="document.documentInvoiceStartDate" type="date"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" class="pr-3" v-if="$store.state.documentActiv === 'InvoiceSales' ">
                <v-text-field outlined hide-details="auto" dense :label="lang.endPeriod" v-model="document.documentInvoiceEndPeriodDate" type="date"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- PARTNER -->
        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">Partner</v-card-title>
          <v-card-text class="pt-5 pb-1">

            <!-- Poravnanje po vrhu, a ne po sredini: kad se ispod OIB-a pojavi
                 poruka o obaveznom polju, taj stupac naraste - sa "center" bi
                 se susjedna polja pomaknula i vise ne bi bila u istoj liniji. -->
            <v-row dense align="start">
              <v-col cols="12" sm="6" md="4" lg="4" class="pr-3">
                <v-autocomplete
                  outlined hide-details="auto"
                  dense
                  v-model="selectPa"
                  :items="partners"
                  :label="lang.SelectPartner"
                  return-object
                  clearable
                  item-text="partnerName"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                <v-text-field
                  outlined hide-details="auto"
                  dense
                  :label="lang.VATID"
                  v-model="document.partnerVATID"
                  :rules="oibPravila"
                  validate-on-blur
                ></v-text-field>
              </v-col>
              <!-- Kvacica stoji uz OIB jer upravo o njoj ovisi trazi li se.
                   Na racunu je OIB obavezan i privatnom kupcu (Fiskalizacija
                   2.0), pa se ondje kvacica ne prikazuje. -->
              <v-col cols="12" sm="6" md="auto" class="pr-3 mt-1"
                     v-if="$store.state.documentActiv !== 'InvoiceSales'">
                <v-checkbox dense hide-details class="mt-0 pt-0"
                  :label="lang.privatePerson"
                  v-model="document.privatePerson"></v-checkbox>
              </v-col>
              <v-col cols="12" sm="12" md="auto" class="text-right ml-md-auto">
                <v-btn text small color="primary" @click="findByVATID()">{{langC.checkVATID}}</v-btn>
                <v-btn text small color="primary" @click="addeditPartner()">{{lang.PartnerSave}}</v-btn>
                <v-btn text small color="primary" @click="showAllPartners()">{{langC.Partners}}</v-btn>
                <v-btn text small color="primary" @click="showPartner()">
                  <v-icon small v-if="!showPart">mdi-chevron-down</v-icon><v-icon small v-if="showPart">mdi-chevron-up</v-icon>
                  {{ showPart ? 'Sakrij podatke' : 'Uredi podatke' }}
                </v-btn>
              </v-col>
            </v-row>

            <!-- Poslovne jedinice kupca iz ePoslovanja. Veliki kupci racun primaju
                 na poslovnu jedinicu, ne na sjediste. -->
            <v-row dense align="center" v-if="poslovnice.length > 0">
              <v-col cols="12" sm="7" md="5" lg="4" class="pr-3">
                <v-autocomplete
                  outlined hide-details="auto"
                  dense
                  v-model="selectPoslovnica"
                  :items="poslovnice"
                  label="Poslovna jedinica kupca"
                  return-object
                  clearable
                  item-text="naziv"
                  item-value="oznaka"
                  :loading="poslovniceRadi"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="5" md="4" lg="4">
                <span v-if="selectPoslovnica" class="text-caption grey--text text--darken-1">
                  Oznaka: {{ selectPoslovnica.oznaka }}
                </span>
              </v-col>
            </v-row>

            <!-- sazetak partnera dok se podaci ne uredjuju -->
            <v-row dense v-if="!showPart">
              <v-col cols="12" class="pb-3">
                <div class="text-subtitle-1 font-weight-medium">{{ document.partnerName }}</div>
                <div class="text-body-2 grey--text text--darken-2">{{ partnerAdresaTxt }}</div>
                <div class="text-body-2 grey--text text--darken-2">{{ partnerKontaktTxt }}</div>
              </v-col>
            </v-row>

            <div v-if="showPart">
              <v-row dense align="start">
                <v-col cols="12" sm="6" md="5" lg="4" class="pr-3">
                  <v-text-field
                    outlined hide-details="auto"
                    dense
                    :label="lang.PartnerName"
                    v-model="document.partnerName"
                    :rules="[rules.required]"
                    validate-on-blur
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field
                    outlined hide-details="auto"
                    dense
                    :label="lang.CompanyEmail"
                    v-model="document.partneremail"
                    :rules="[rules.required]"
                    validate-on-blur
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-checkbox dense hide-details class="mt-1" :label="lang.exculdeEmail" v-model="document.exculdeEmail"></v-checkbox>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.Street" v-model="document.partnerStreet"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="1" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.BuildingNameNumber" v-model="document.partnerBuildingNameNumber"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.City" v-model="document.partnerCity"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="1" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.Postcode" v-model="document.partnerPostcode"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" sm="3" md="2" lg="1" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.SecretaryTitle" v-model="document.partnerSecretaryTitle"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.SecretaryFirst" v-model="document.partnerSecretaryFirst"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.SecretaryLast" v-model="document.partnerSecretaryLast"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.SecretaryEmail" v-model="document.partnerSecretaryEmail"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.SecretaryPhone" v-model="document.partnerPhones"></v-text-field>
                </v-col>
              </v-row>
            </div>

          </v-card-text>
        </v-card>

        <!-- UVJETI I VALUTA -->
        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">Uvjeti i valuta</v-card-title>
          <v-card-text class="pt-5 pb-1">
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                <v-autocomplete
                  outlined hide-details="auto"
                  dense
                  :items="banks"
                  v-model="selectBank"
                  label="Ime banke"
                  item-text="BankName"
                  item-value="id"
                  return-object
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                <v-select outlined hide-details="auto" dense :label="lang.HomeCurrency" :items="currnecyType" v-model="document.documentHomeCurrency" value="document.documentHomeCurrency"></v-select>
              </v-col>
              <v-col cols="6" sm="3" md="2" lg="2" class="pr-3" v-if="!importPurchase && !showOnlyEUR">
                <v-text-field outlined hide-details="auto" dense :label="lang.ExchangeRate" v-model.number="document.documentExRate" type="number"></v-text-field>
              </v-col>
              <v-col cols="6" sm="3" md="2" lg="2" class="pr-3" v-if="!showOnlyEUR">
                <v-select outlined hide-details="auto" dense :label="lang.SecodnaryCurrency" :items="currnecyType" v-model="document.documentForeignCurrency" value="document.documentForeignCurrency"></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2" class="pr-3" v-if="have8">
                <v-text-field outlined hide-details="auto" dense :label="lang.documentTotalAmountPayInAdvance" v-model.number="document.documentTotalAmountPayInAdvance" type="number"></v-text-field>
              </v-col>
              <!-- Kvacice idu desno u isti red, a ne u zaseban red ispod polja:
                   tako kartica gubi cijeli jedan red visine, a obrazac se manje
                   skrola. Na uskom ekranu "ml-md-auto" ne djeluje pa se spuste
                   ispod, kako i treba. -->
              <v-col cols="12" md="auto" class="ml-md-auto kvacice-uvjeti">
                <v-checkbox dense hide-details class="mt-0 pt-0" :label="lang.exportDoc" v-model="document.exportDoc"></v-checkbox>
                <v-checkbox dense hide-details class="mt-0 pt-0" :label="lang.PPO" v-model="document.PPO"></v-checkbox>
                <v-checkbox dense hide-details class="mt-0 pt-0" :label="lang.validContract" v-model="document.validContract" v-if="documentName === 'ContractSales'"></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- SERVIS -->
        <!-- Izbornici stoje u naslovnoj traci, kao "Status" na kartici
             napomena. Dva do tri padajuca izbornika ne trebaju vlastito tijelo
             kartice: prije je cijela kartica bila visoka 116 px, od cega je
             desna polovica reda stajala prazna. -->
        <v-card outlined class="mb-3" v-if="have5 || $store.state.documentActiv === 'ServiceNotes' || have7">
          <v-card-title class="naslov-kartice naslov-s-poljima">
            Servis
            <v-spacer></v-spacer>
            <div class="polje-u-naslovu" v-if="have5">
              <v-select outlined hide-details dense :label="lang.ServiceStatus" :items="statusType" v-model="document.status" value="document.status"></v-select>
            </div>
            <div class="polje-u-naslovu" v-if="$store.state.documentActiv === 'ServiceNotes'">
              <v-select outlined hide-details dense :label="lang.ServiceDoneBy" :items="users"
                item-text="email"
                item-value="email"
                v-model="document.deliveryCurrier"></v-select>
            </div>
            <div class="polje-u-naslovu" v-if="have7">
              <v-select
                outlined hide-details
                dense
                label="Status naloga"
                :items="productiontypes"
                v-model="selectPT"
                value="productiontypes.value"
                single-line
                return-object
                clearable
              ></v-select>
            </div>
          </v-card-title>
        </v-card>

        <!-- DOBAVLJACEV DOKUMENT -->
        <v-card outlined class="mb-3" v-if="have6">
          <v-card-title class="naslov-kartice">Dobavljačev dokument</v-card-title>
          <v-card-text class="pt-5 pb-1">
            <v-row dense>
              <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                <v-text-field outlined hide-details="auto" dense :label="lang.supplierDocument" v-model="document.supplierDocument"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                <v-text-field outlined hide-details="auto" dense :label="lang.supplierDocumentNr" v-model="document.supplierDocumentNr"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                <v-dialog
                  ref="dialog5"
                  persistent
                  v-model="modal5"
                  width="290px"
                  :return-value.sync="document.supplierDocumentDate"
                >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined hide-details="auto"
                    dense
                    v-model="document.supplierDocumentDate"
                    :label="lang.supplierDocumentDate"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                  <v-date-picker v-model="document.supplierDocumentDate" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="modal5 = false">{{langC.Cancel}}</v-btn>
                    <v-btn color="primary" @click="$refs.dialog5.save(document.supplierDocumentDate)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="6" md="4" lg="2" class="pr-3">
                <v-text-field outlined hide-details="auto" dense :label="lang.BookID" v-model="document.BookID"></v-text-field>
              </v-col>
            </v-row>

            <div v-if="document.exportDoc">
              <v-divider class="my-3"></v-divider>
              <div class="text-subtitle-2 grey--text text--darken-1 pb-2">Uvoz — JCD i troškovi</div>
              <v-row dense>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.UCDnumber" v-model="document.UCDnumber"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-dialog
                    ref="dialogUCD"
                    persistent
                    v-model="modalUCD"
                    width="290px"
                    :return-value.sync="locUCDdate"
                    :retain-focus="false"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined hide-details="auto"
                      dense
                      v-model="locUCDdate"
                      :label="lang.UCDdate"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                    <v-date-picker v-model="locUCDdate" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" @click="modalUCD = false">{{langC.Cancel}}</v-btn>
                      <v-btn color="primary" @click="$refs.dialogUCD.save(locUCDdate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.importAmount" v-model.number="document.importAmount" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.exRate" v-model.number="document.exRate" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.domecilAmount" v-model.number="document.domecilAmount" type="number" disabled></v-text-field>
                </v-col>
              </v-row>
              <v-row dense align="center">
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.customAmount" v-model.number="document.customAmount" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.bankExp" v-model.number="document.bankExp" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.forwarderExp" v-model.number="document.forwarderExp" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.transportExp" v-model.number="document.transportExp" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.otherExp" v-model.number="document.otherExp" type="number"></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="2" lg="2">
                  <span class="text-subtitle-1 font-weight-medium">{{totalFullExp}}</span>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>

        <!-- VEZA I NAPOMENE -->
        <v-card outlined class="mb-3">
          <v-card-title class="naslov-kartice">
            Veza i napomene
            <v-spacer></v-spacer>
            <div style="max-width:220px" v-if="$store.state.documentActiv !== 'ServiceNotes' && !have7">
              <v-select
                outlined
                dense
                hide-details
                label="Status"
                :items="docStatus"
                v-model="selectDS"
                item-text="docStatus"
                item-value="id"
                single-line
                return-object
                persistent-hint
                clearable
              ></v-select>
            </div>
          </v-card-title>
          <v-card-text class="pt-5 pb-1">

            <!-- Napomene lijevo, veze desno. Veze su prije stajale u zasebnom
                 redu iznad napomena, pa je cijela kartica bila visa za taj red,
                 a desna trecina je stajala prazna. Ovako napomene pocinju na
                 vrhu i manje se skrola. -->
            <v-row dense>
              <v-col cols="12" lg="8" class="pr-3">

                <v-row dense v-if="have1">
                  <v-col cols="12">
                    <v-text-field outlined hide-details="auto" dense :label="lang1" v-model="document.documentDescription4" v-if="show1"></v-text-field>
                    <v-btn text small color="primary" class="pl-0" @click="showOn1()" v-if="!show1">
                      <v-icon small>mdi-chevron-down</v-icon>{{lang.Description4show}}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row dense v-if="have2">
                  <v-col cols="12">
                    <v-textarea outlined hide-details="auto" dense rows="3" :label="lang2" v-model="document.documentDescription1" v-if="show2"></v-textarea>
                    <v-btn text small color="primary" class="pl-0" @click="showOn2()" v-if="!show2">
                      <v-icon small>mdi-chevron-down</v-icon>{{lang.Description1show}}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row dense v-if="have3">
                  <v-col cols="12">
                    <v-textarea outlined hide-details="auto" dense rows="3" :label="lang3" v-model="document.documentDescription5" v-if="show3"></v-textarea>
                    <v-btn text small color="primary" class="pl-0" @click="showOn3()" v-if="!show3">
                      <v-icon small>mdi-chevron-down</v-icon>{{lang.Description5show}}
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row dense v-if="have4">
                  <v-col cols="12">
                    <v-textarea outlined hide-details="auto" dense rows="3" :label="lang4" v-model="document.documentDescription3" v-if="show4"></v-textarea>
                    <v-btn text small color="primary" class="pl-0" @click="showOn4()" v-if="!show4">
                      <v-icon small>mdi-chevron-down</v-icon>{{lang.Description3show}}
                    </v-btn>
                  </v-col>
                </v-row>

              </v-col>

              <v-col cols="12" lg="4">
                <v-text-field outlined hide-details="auto" dense :label="lang.documentConnNameFrom" v-model="document.documentConnNameFrom"></v-text-field>
                <v-text-field outlined hide-details="auto" dense :label="lang.documentConnName" v-model="document.documentConnName"></v-text-field>
                <!-- Gotova napomena i dugovanje idu uz tekst napomene, pa se
                     prikazuju samo kad je ta napomena otvorena. -->
                <template v-if="have3 && show3">
                  <v-select
                    outlined hide-details="auto"
                    dense
                    v-if="showDD"
                    v-model="selectDD"
                    :items="docDesc"
                    item-text="docsmall"
                    item-value="description"
                    label="Napomena"
                    persistent-hint
                    return-object
                    single-line
                    clearable
                  ></v-select>
                  <v-btn text small color="primary" class="pl-0" @click="addOpenStatement()">{{lang.OpenStatement}}</v-btn>
                </template>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>

        <!-- eRACUN -->
        <v-card outlined class="mb-3" v-if="$store.state.documentActiv === 'InvoiceSales' ">
          <v-card-title class="naslov-kartice">
            eRačun
            <v-spacer></v-spacer>
            <v-checkbox dense hide-details class="mt-0 pt-0" :label="lang.eRacun" v-model="document.eRacun"></v-checkbox>
          </v-card-title>
          <v-card-text class="pt-3 pb-1">
            <v-btn text small color="primary" class="pl-0" @click="showeRacunOn()" v-if="!showeRacun">
              <v-icon small>mdi-chevron-down</v-icon>Tip dokumenta, poslovni proces i reference
            </v-btn>
            <v-btn text small color="primary" class="pl-0" @click="showeRacunOn()" v-if="showeRacun">
              <v-icon small>mdi-chevron-up</v-icon>Sakrij postavke
            </v-btn>

            <div v-if="showeRacun" class="mt-2">
              <v-row dense>
                <v-col cols="12" md="6" lg="5" class="pr-3">
                  <v-autocomplete
                    outlined hide-details="auto"
                    dense
                    :items="tipdok"
                    v-model="selecttipdok"
                    label="Tip dokumenta"
                    item-text="fullText"
                    item-value="value"
                    return-object
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" lg="5" class="pr-3">
                  <v-autocomplete
                    outlined hide-details="auto"
                    dense
                    :items="pospro"
                    v-model="selectpospro"
                    label="Poslovni proces"
                    item-text="text"
                    item-value="value"
                    return-object
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>

              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaPrethodniRacun" v-model="document.RefNaPrethodniRacun"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaPrethodniRacunDatum" v-model="document.RefNaPrethodniRacunDatum" type="date"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-btn text small color="primary" class="pl-0" @click="cardSales()">Kartica</v-btn>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaKupca" v-model="document.RefNaKupca"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaProjekt" v-model="document.RefNaProjekt"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaUgovor" v-model="document.RefNaUgovor"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaNarudzbu" v-model="document.RefNaNarudzbu"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaProdajniNalog" v-model="document.RefNaProdajniNalog"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaPrimku" v-model="document.RefNaPrimku"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaOtpremnicu" v-model="document.RefNaOtpremnicu"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.RefNaZahtjev" v-model="document.RefNaZahtjev"></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.First" v-model="document.First"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.Last" v-model="document.Last"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3" class="pr-3">
                  <v-text-field outlined hide-details="auto" dense :label="lang.uservatID" v-model="document.uservatID"></v-text-field>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>

        {{error}}
        <div class="pink darken-2" v-html="error" />
        <v-snackbar
          v-model="snackbar"
          bottom
          :timeout="timeout"
          :color="color"
          >
          {{ text }}
        </v-snackbar>

        <!-- Zbrojevi i radnje uvijek na dnu ekrana -->
        <div class="podnozje-dok">
          <div class="stavka">
            <span>Osnovica</span>
            <b>{{ localMoney(document.documentTotalAmountNetto) }}</b>
          </div>
          <div class="stavka">
            <span>Popust</span>
            <b>{{ localMoney(document.documentTotalAmountDirectD1) }}</b>
          </div>
          <div class="stavka">
            <span>PDV</span>
            <b>{{ localMoney(document.documentTotalVAT1Amount) }}</b>
          </div>
          <div class="stavka">
            <span>Za platiti</span>
            <b>{{ localMoney(document.documentTotalAmountBrutto) }}</b>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            class="primary mr-1"
            color="success"
            :disabled="!valid"
            @click="validate">
            <span v-if="this.$store.state.editItem  === 0">
              {{langC.CreateNew}} {{ documentNameLoc }}
            </span>
            <span v-if="this.$store.state.editItem === 1">
              {{langC.Save}} {{ documentNameLoc }} {{document.documentId}}
            </span>
          </v-btn>
          <v-btn
            color="green"
            @click="documentlist">
            {{langC.Back}}
          </v-btn>
        </div>

      </v-col>
    </v-row>

    <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="12" lg="12" xs="12" sm="12" md="12" class="pa-0">
        <div v-if="this.showPartners">
          <PartnerListFast />
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters justify="center" class="pa-0">
      <v-col xl="12" lg="12" xs="12" sm="12" md="12" class="pa-0">
        <div v-if="this.showCardSales">
          <DocumentCardSales />
        </div>
      </v-col>
    </v-row>
  </v-container>
</v-form>
</template>
<script>
import dayjs from 'dayjs'
import PartnerService from '@/services/PartnerService'
import SudRegService from '@/services/SudRegService'
import { popuni as popuniIzRegistra, opis as opisRegistra } from '@/snippets/sudregPopuna'
import EIzvjestavanjeService from '@/services/EIzvjestavanjeService'

// Poslovne jedinice po OIB-u, zapamcene za trajanja sjednice. Isti partner se
// bira i po vise puta (novi racun, ispravak), a popis se rijetko mijenja.
const zapamcenePoslovnice = new Map()

// Greska u postavkama (kljuc ne odgovara serveru) javlja se jednom po firmi, da
// ne iskace pri svakom odabiru partnera.
const javljenaGreska = new Set()
import BankAccountService from '@/services/BankAccountService'
import UserService from '@/services/UserService'
import DocumentService from '@/services/DocumentService'
import DocumentDetailService from '@/services/DocumentDetailService'
import DocumentStatusService from '@/services/DocumentStatusService'
import DocDescService from '@/services/DocDescService'
import MainLedgerDetailService from '@/services/MainLedgerDetailService'
import PartnerListFast from '../Partner/PartnerListFast'
import DocumentCardSales from './DocumentCardSales'
import { testLastUpdate, newUpdates } from '@/services/TestLastUpdate'
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dateFormat from '@/snippets/dateFormat'
import { addUpdatePartner} from '@/snippets/partnerCheck'
import { defDocument } from './documentHelper'
import { round, parseNum, moneyFormat } from '@/snippets/allSnippets'
import { mapGetters } from 'vuex'
import { domacaValuta, tecajValute, uKunama } from '@/snippets/domacaValuta'

export default {
  name: 'documentcreate',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      vrijeme: "14:00",
      saving: false,
      valid: true,
      lazy: false,
      rules: {
        required: value => !!value || '*'
      },
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      menu: false,
      menu2: false,
      menu3: false,
      dateFormatted: null,
      dateFormatted2: null,
      modal: false,
      date1: null,
      date2: null,
      modal1: false,
      modal2: false,
      modal3: false,
      modal4: false,
      modal5: false,
      modalT: false,
      modalUCD: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialogT: false,
      dialogUCD: false,
      have1: true, 
      have2: true,
      have3: true,
      have4: true,
      have5: false,
      have6: false,
      have7: false,
      have8: false,
      lang1: '',
      lang2: '',
      lang3: '',
      lang4: '',
      lang5: '',
      msg: '',
      documentName: '',
      documentNameLoc: '',
      document: {},
      error: null,
      localError: false,
      newDocument: {},
      confpassword: '',
      size: 'sm',
      required: (value) => !!value || 'Required.',
      partners: [],
      employes: [],
      banks: [],
      currnecy: [],
      users: [],
      productiontypes: [],
      docStatus: [],
      docDesc: [],
      CompanyId: 0,
      selectPa: {},
      selectPT: {},
      selectDS: {},
      selectDD: {},
      firstTimePa: true,
      selectId: 0,
      search: null,
      selectBank: {},
      selectBankId: 0,
      firstTimeBank: true,
      selectCR: {},
      selectUs: {},
      documentDate: null,
      documentTime: null,
      invoiceStartDate: null,
      invoiceEndDate: null,
      supplierDocumentDate: null,
      mainQuery: {},
      mainQuery2 : {},
      currnecyType: [
        { text: 'Kn', value: 'Kn' },
        { text: 'EUR', value: 'EUR' },
        { text: 'USD', value: 'USD' },
        { text: 'GBP', value: 'GBP' },
        { text: 'CHF', value: 'CHF' }
      ],
      statusType: [
        { text: 'Prijavljeno', value: 'Reported' },
        { text: 'Zaprimljeno', value: 'Received' },
        { text: 'U tijeku', value: 'InProgress' },
        { text: 'Završeno', value: 'Done' },
        { text: 'Preuzeto', value: 'Delivered' }
      ],
      money: {
        prefix: '= ',
        suffix: ' ',
        precision: 3
      },
      price: 7.500,
      docName: '',
      lang: {},
      langC: {},
      mount: true,
      reqVATID: false,
      haveItem: null,
      privateP: true,
      mainledgerAna: {},
      showPartners: false,
      totalFullExp: '',
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      showNote: false,
      locUCDdate : null,
      importPurchase: false,
      showDD: false,
      showOnlyEUR: true,
      nrDays: 15,
      findpartnerbyid: false,
      partnerRadi: false,
      poslovnice: [],
      selectPoslovnica: null,
      poslovniceRadi: false,
      showContractSales: false,
      showPart:false,
      showeRacun: false,
      pospro:[],
      selectpospro:{},
      tipdok:[],
      selecttipdok: {},
      noChangeType: false,
      showCardSales: false
    }
  },
  components: {
    PartnerListFast,
    DocumentCardSales
  },
  async mounted () {

    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
    }
    this.noChangeType = this.$store.state.documentActivItems && this.$store.state.documentActivItems.length > 0 ? true: false
    this.findpartnerbyid = false
    this.showOnlyEUR = !uKunama(this.$store.state.businessYear)
    this.privateP = this.$store.state.user ? this.$store.state.user.privatePartner : true
    // if is private marked then find only by id
    if (this.privateP) {
      this.findpartnerbyid = true
    }
    this.lang1 = this.lang.Description4
    this.lang2 = this.lang.Description1
    this.lang3 = this.lang.Description5
    this.lang4 = this.lang.Description3
    if (this.$store.state.companyid) {
      this.CompanyId = await this.$store.state.companyid
      this.mainQuery.CompanyId = await this.$store.state.companyid
    }
    this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2026
    this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
    this.document.documentSide = this.$store.state.documentSide ? this.$store.state.documentSide : 0
    
    this.saving = true
    this.productiontypes = this.$store.state.productiontype
    this.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
    this.documentNameLoc = this.$store.state.documentActivLoc
    //await checkPartners(0)
    await testLastUpdate()
    if (this.$store.state.partnerStore) {
      this.partners = this.$store.state.partnerStore
    }
    //this.partners = (await PartnerService.index()).data.partners
    this.banks = (await BankAccountService.choose(this.mainQuery)).data.bankAccounts
    this.users = (await UserService.choose(this.mainQuery)).data.users
    this.docStatus = (await DocumentStatusService.index(this.mainQuery)).data.documenttypes
    this.docDesc = (await DocDescService.choose(this.mainQuery)).data.docdescs
    this.showDD = this.docDesc && this.docDesc.length > 0 ? true : false
    if (this.$store.state.eRacunPoslovniProces) {
      this.pospro = this.$store.state.eRacunPoslovniProces
      this.selectpospro = this.$store.state.eRacunPoslovniProces.find(pp => pp.value === 'P1')
    } 
    if (this.$store.state.eRacunTipDokumenta) {
      this.tipdok = this.$store.state.eRacunTipDokumenta
      this.selecttipdok = this.$store.state.eRacunTipDokumenta.find(pp => pp.default === true)
    } 
    
    this.saving = false
    // edit current record
     if (this.$store.state.editItem === 1) {
        this.documentName = this.$store.state.documentActiv
        this.documentNameLoc = this.$store.state.documentActivLoc        
        if (this.$store.state.documentActivHead) {
          this.document = this.$store.state.documentActivHead
          if (this.document.partnerId && parseInt(this.document.partnerId) > 0 ) {    
            this.selectId = parseInt(this.document.partnerId)
            this.selectPa = this.partners.find(partner => (partner.id === parseInt(this.document.partnerId)))
            if (Object.keys(this.selectPa).length === 0) {
              this.selectPa = this.partners.find(partner => (partner.partnerVATID === (this.document.partnerVATID)))
              this.$store.dispatch('setPartnerid', this.selectPa.id)
            }
          }
          this.selectBankId  =this.document.bankAccountId ? parseInt(this.document.bankAccountId) : null
          this.selectBank = this.selectBankId ? this.banks.find(bank => (bank.id === this.selectBankId)) : null
          this.document.documentTime = this.document.documentTime ? this.document.documentTime.substr(0,5) : null
          this.selectPT = this.document.productiontype ? this.document.productiontype : null
          this.show1 = this.document.documentDescription4 && this.document.documentDescription4.trim().length > 0 ? true : false
          this.show2 = this.document.documentDescription1 && this.document.documentDescription1.trim().length > 0 ? true : false
          this.show3 = this.document.documentDescription5 && this.document.documentDescription5.trim().length > 0 ? true : false
          this.show4 = this.document.documentDescription3 && this.document.documentDescription3.trim().length > 0 ? true : false

          this.locUCDdate = dayjs(this.document.UCDdate).format('YYYY-MM-DD')
          const firstDate = this.document.documentDate ? new Date(this.document.documentDate) : null
          const lastDate = this.document.documentInvoiceEndDate ? new Date(this.document.documentInvoiceEndDate) : null
          const difference = firstDate && lastDate ? lastDate.getTime() - firstDate.getTime() : 0
          this.nrDays = Math.ceil(difference / (1000 * 3600 * 24))
          if (this.document.eRacunPoslovniProcesSifra) {
            this.selectpospro = this.$store.state.eRacunPoslovniProces.find(pp => pp.value === this.document.eRacunPoslovniProcesSifra)
          }
          if (!this.document.eRacunPoslovniProcesSifra) {
            this.selectpospro = this.$store.state.eRacunPoslovniProces.find(pp => pp.value === 'P1')
          }
          if (this.document.TipDokumenta) {
            this.selecttipdok = this.$store.state.eRacunTipDokumenta.find(pp => pp.text === this.document.TipDokumenta)
          }
          if (!this.document.TipDokumenta) {
            this.selecttipdok = this.$store.state.eRacunTipDokumenta.find(pp => pp.default === true)
          }

          // Kod ispravka se selectPa postavlja izravno, pa promatrac ne zove
          // findPartner (i s pravom - podaci partnera vec su na racunu). Zato se
          // poslovnice dohvacaju ovdje, da se vidi koja je bila odabrana.
          await this.ucitajPoslovnice(this.document.partnerVATID)

        } else {
          // if in any case dont have all data in head, return to list
          this.text = 'Error! Sorry... some error happend. Need to return.'
          this.color = 'red'
          this.snackbar = true
          this.timeout = 4000
            this.$router.push({
              name: 'document'
            })
        }
     }   
    // create NEW
    if (this.$store.state.editItem === 0) {
      this.document = defDocument()
      if (this.$store.state.companyid) {
        this.CompanyId = await this.$store.state.companyid
        this.mainQuery.CompanyId = await this.$store.state.companyid
      }
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2026
      this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
      this.document.documentSide = this.$store.state.documentSide ? this.$store.state.documentSide : 0

      this.document.UserId = this.$store.state.user.id ? this.$store.state.user.id : ''
      this.document.email = this.$store.state.user.email ? this.$store.state.user.email : 'test@cegrupa.com'
      this.document.First = this.$store.state.user.First ? this.$store.state.user.First : 'NoFirst'
      this.document.Last = this.$store.state.user.Last ? this.$store.state.user.Last : 'NoLast'
      this.document.uservatID = this.$store.state.user.vatID ? this.$store.state.user.vatID : '12345678901'
      this.document.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
      this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
      this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      this.mainQuery.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
      if (this.$store.state.documentActiv) {
        this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
        this.document.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : ''
        this.docName = this.$store.state.documentActiv
        if (this.docName === 'InquirySales' || this.docName === 'QuoteSales' || this.docName === 'OrderSales' || this.docName === 'DeliveryNoteSales' || this.docName === 'InvoiceSales' || this.docName === 'ContractSales') {
          this.document.documentAnalysis = 1
          this.$store.dispatch('setDocumentAnalysis', 1)
        }
        if (this.docName === 'RequestPurchase' || this.docName === 'InquiryPurchase' || this.docName === 'OrderPurchase' || this.docName === 'ReceiptPurchase' || this.docName === 'ReturnPurchase') {
          this.document.documentAnalysis = 2
          this.$store.dispatch('setDocumentAnalysis', 2)
        }
        if (!this.document.documentAnalysis || this.document.documentAnalysis === 0) {
          this.document.documentAnalysis = 1
          this.mainQuery.documentAnalysis = 1
          this.$store.dispatch('setDocumentAnalysis', 1)
        }
      }
      this.document.documentSide = this.$store.state.documentSide ? this.$store.state.documentSide : 1  
      if (this.docName === 'InvoiceSales') {
        this.document.documentDescription5 = this.$store.state.companyActiv.CompanyInvoiceMemo
        this.document.eRacun = true
        this.document.eRacunPoslovniProces = "P1-Fakturiranje isporuka dobara i usluga preko narudžbi na temelju ugovora"
        this.document.eRacunPoslovniProcesSifra = "P1"

        this.document.TipDokumenta
        this.document.TipDokumentaBroj
      }
      if (this.banks) {
        this.selectBank = this.banks ? this.banks.find(bank => (bank.DefaultAccount === true)) : {}
        this.selectBankId  = this.selectBank ? parseInt(this.selectBank.id) : null
      }
      let locDate1 = new Date()
      locDate1.getDate()
      locDate1.getMonth() + 1
      locDate1.getFullYear()
      const nrOfDays = this.$store.state.companyActiv.CompanyInvoiceDefDays ? parseInt(this.$store.state.companyActiv.CompanyInvoiceDefDays) : 15
      this.document.documentDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentTime = dayjs(new Date()).format('HH:mm')
      this.document.documentInvoiceStartDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentInvoiceEndDate = dayjs(new Date()).add(nrOfDays, 'days').format('YYYY-MM-DD')
      this.document.documentInvoiceEndPeriodDate = dayjs(new Date()).format('YYYY-MM-DD')
      this.document.documentHomeCurrency = domacaValuta(this.$store.state.businessYear)
      this.document.documentForeignCurrency = 'EUR'
      this.document.documentExRate = tecajValute(this.$store.state.businessYear)
      this.locUCDdate = dayjs(new Date()).format('YYYY-MM-DD')
    }
     if (this.documentName === 'ServiceNotes') {
        this.have1 = true
        this.have2 = true
        this.have3 = true
        this.have4 = true
        this.have5 = true
        this.lang1 = this.lang.ServiceItem
        this.lang2 = this.lang.ServiceProblem
        this.lang3 = this.lang.ServiceDescription
        this.lang5 = this.lang.ServiceStatus
      }
      if (this.documentName === 'Inventory') {
        this.have1 = false
        this.have2 = false
        this.have3 = false
        this.have4 = true
        this.have5 = false
      }
      if (this.documentName === 'ReceiptPurchase' || this.documentName === 'ReturnPurchase') {
        this.have6 = true
      }
      if (this.documentName === 'WorkingOrder') {
        this.have7 = true
      }
      if (this.documentName === 'InvoiceSales') {
        this.have8 = true
      }
      if (this.have6) {
        if (this.document.exportDoc) {
          this.importPurchase = true
        }
      }
    this.mount = false
    this.$refs.docdate.focus()
  },
  computed: {
    // Kad se trazi OIB kupca.
    //
    // Na racunu uvijek, i privatnom kupcu - to trazi Fiskalizacija 2.0.
    // Na ostalim dokumentima (servisni nalog, ponuda, otpremnica) privatnom
    // kupcu se ne trazi; fizicka osoba donese uredjaj na popravak i OIB tu
    // nema svrhu. Oznaka dolazi s odabranog partnera ili s kvacice na kartici
    // partnera.
    oibObavezan () {
      if (this.$store.state.documentActiv === 'InvoiceSales') { return true }
      return !this.document.privatePerson
    },
    // Kao racunato svojstvo, a ne ternar u predlosku. Ternar bi pri svakom
    // iscrtavanju stvorio novo polje pravila; Vuetify to vidi kao promjenu
    // pravila i ponisti stanje provjere, pa se greska za prazan OIB vise ne
    // bi prikazala. Racunato svojstvo zadrzi isto polje dok se uvjet ne
    // promijeni.
    oibPravila () {
      return this.oibObavezan ? [this.rules.required] : []
    },
    // Sazetak partnera u kartici, dok se podaci ne uredjuju. Spojnica ide samo
    // izmedju podataka kojih doista ima.
    partnerAdresaTxt () {
      const d = this.document
      const ulica = [d.partnerStreet, d.partnerBuildingNameNumber].filter(x => x).join(' ')
      const mjesto = [d.partnerPostcode, d.partnerCity].filter(x => x).join(' ')
      return [d.partnerVATID ? 'OIB ' + d.partnerVATID : '', ulica, mjesto].filter(x => x).join(' · ')
    },
    partnerKontaktTxt () {
      const d = this.document
      const jedinica = this.selectPoslovnica && this.selectPoslovnica.naziv ? 'Poslovnica: ' + this.selectPoslovnica.naziv : ''
      return [d.partneremail, d.partnerPhones, jedinica].filter(x => x).join(' · ')
    },
    formIsValid () {
      return this.document.email !== '' &&
        this.document.First !== '' &&
        this.document.Last !== '' &&
        this.document.documentId !== '' &&
        this.document.documentDate !== ''
    },
    ...mapGetters({
      myPartnerid: 'NeedPartnerid',
      documentFrom: 'NeedDocumentFrom'
    }),
  },
  methods: {
    localMoney (iznos) {
      return moneyFormat(iznos)
    },
    showPartner() {
      this.showPart = !this.showPart
    },
    cardSales() {
      this.showCardSales = !this.showCardSales
    },
    showNoteOn() {
      this.showNote = !this.showNote
    },
    showeRacunOn() {
      this.showeRacun = !this.showeRacun
    },
    showOn1() {
      this.show1 = !this.show1
    },
    showOn2() {
      this.show2 = !this.show2
    },
    showOn3() {
      this.show3 = !this.show3
    },
    showOn4() {
      this.show4 = !this.show4
    },
    showAllPartners() {
      this.showPartners = !this.showPartners
    },
    validate () {
      if (this.$refs.form.validate()) {
        //this.snackbar = true
        this.register()
      }
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    // OIB se trazi u dva koraka: prvo nasi partneri, pa sudski registar.
    // Partner kojeg vec imamo ima prednost - u njemu je ono sto je korisnik
    // sam ispravio (IBAN, kontakt, naziv kakav zeli na racunu).
    // Ako ga nema nigdje, to nije greska: obrta i fizickih osoba u sudskom
    // registru i nema, pa korisnik podatke upise sam.
    async findByVATID() {
      if (!this.document.partnerVATID) { return }
      try {
        const {data} = await SudRegService.poOibu({
          CompanyId: this.$store.state.companyid,
          oib: this.document.partnerVATID
        })

        if (data.izvor === 'partner') {
          // selectPa postavlja findPartner, po id-u; rucno postavljanje ovdje
          // pokretalo je drugi krug ucitavanja.
          await this.findPartner(data.partner.id)
          this.text = 'OK!'
          this.color = 'green'
          this.snackbar = true
          return
        }

        if (data.izvor === 'sudreg') {
          // Partner iz registra nije nas partner, pa se izbor prazni - ali pod
          // zastavicom partnerRadi. Bez nje promatrac selectPa pozove
          // clearPartner() i pobrise sve, ukljucujuci i OIB koji je upravo
          // upisan.
          this.partnerRadi = true
          try {
            this.selectPa = null
            this.document.partnerId = null
            // Ovdje se prepisuje i ono sto vec stoji: korisnik je sam kliknuo
            // na provjeru OIB-a na racunu koji tek radi.
            popuniIzRegistra(this.document, data.partner, true)
          } finally {
            await this.$nextTick()
            this.partnerRadi = false
          }
          this.text = 'Iz sudskog registra: ' + opisRegistra(data.partner) + '. Provjerite podatke.'
          this.color = data.partner.sudreg && data.partner.sudreg.aktivan === false ? 'orange' : 'blue'
          this.snackbar = true
          this.timeout = 6000
          return
        }

        this.text = data.poruka || 'Partner s tim OIB-om nije pronađen.'
        this.color = 'orange'
        this.snackbar = true
        this.timeout = 5000
      } catch (err) {
        this.text = 'Greška kod traženja partnera: ' + (err.message || err)
        this.color = 'red'
        this.snackbar = true
      }
    },
    async register () {
      try {
        // write new document to database
        // this.localError = false   
        const haveYear = dayjs(this.document.documentDate).year()
        if (haveYear !== this.$store.state.businessYear) {
          this.text = this.lang.wrongBussinesYear
          this.color = 'red'
          this.snackbar = true
          this.timeout = 3000
          return
        }

        if (!this.document.exportDoc) {
          const partVatLeght = this.document.partnerVATID.trim().length
          if (partVatLeght !== 11) {
            this.text = this.lang.PartnerErrorVAT3
            this.color = 'red'
            this.snackbar = true
            this.timeout = 3000
            this.reqVATID = true
            return
          }
        }

            this.document.documentTime = this.document.documentTime.substr(0,5)
            this.document.UCDdate = this.locUCDdate ?  dayjs(this.locUCDdate): null
            if (this.document.exportDoc && this.have6) {
              this.document.documentExRate = this.document.exRate && parseNum(this.document.exRate, 2) !== 0 ? this.document.exRate : 1
            }
            // create NEW
            if (this.$store.state.editItem === 0) {
              this.document.documentId = null

              if (!this.document.partnerNameShort || (this.document.partnerNameShort.trim()).length < 1) {
                this.document.partnerNameShort = this.document.partnerName.replace(/[\W_]/g, '')
              }
              if (!this.document.partnerNameDatabase || (this.document.partnerNameDatabase.trim()).length < 1) {
                this.document.partnerNameDatabase = this.document.partnerName.replace(/[\W_]/g, '')
              }
              if (this.documentName === 'ServiceNotes' && !this.document.status) {
                this.document.status = 'Received'
              }
              const lastNr = {}
              const side = this.$store.state.documentSide ? this.$store.state.documentSide : 3
              lastNr.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
              lastNr.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
              if (side === 1 || side === 2) {
                lastNr.WareHouseId = this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1
              }
              lastNr.documentName = this.documentName

              this.document.CompanyNameDatabase = this.$store.state.companyName ? this.$store.state.companyName : ''
              this.document.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2024
             
              console.log('lastNr on doc create', lastNr)
              this.document.documentId = parseInt((await DocumentService.choose(lastNr)).data.docNumber)
              if (this.document.documentId && this.document.documentId > 0)
              {
                this.document.documentIdGeneral = this.$store.state.companyName + '-' + this.$store.state.businessYear + '-' + this.$store.state.documentActiv + '-' + this.document.documentId + '-' + (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
                this.document.WareHouseId = (this.$store.state.warehousemarkid ? this.$store.state.warehousemarkid : 1)
                const whObj =  this.$store.state.warehouseState ? this.$store.state.warehouseState.find(whID => whID.WareHouseId === this.$store.state.warehousemarkid) : []
                this.document.WareHouseName = whObj && whObj.WareHouseName ? whObj.WareHouseName : ''
                await DocumentService.post(this.document)
                  .then(response => {
                    this.text = this.lang.DocumentSavedOK + response.statusText
                    this.color = 'green'
                    this.snackbar = true
                    this.timeout = 2000
                    this.$store.dispatch('seteditItem', 0)
                    this.$store.dispatch('setDocumentActivHead', {})
                    this.$store.dispatch('setDocumentActivItems', [])
                    const newDoc = response.data && response.data.newDoc ? response.data.newDoc : null
                    if (newDoc) {
                      this.navigateTo(newDoc)
                    }
                  })
                  .catch(err => {
                    // eslint-disable-next-line
                    console.log(err)
                    this.text = 'Error post!' + err
                    this.color = 'red'
                    this.snackbar = true
                    this.timeout = 4000
                  })
              }
              
            }
            // edit current
            if (this.$store.state.editItem === 1) {
              await DocumentService.put(this.document)
                .then(response => {
                  this.text = this.lang.DocumentSavedOK + response.statusText
                  this.color = 'green'
                  this.snackbar = true
                  this.timeout = 2000
                  this.$store.dispatch('seteditItem', 0)
                  this.$store.dispatch('setDocumentActivHead', {})
                  this.$store.dispatch('setDocumentActivItems', [])
                  const newDoc = response.data && response.data.newDoc ? response.data.newDoc : null
                  if (newDoc) {
                    this.navigateTo(newDoc)
                  } else {
                    this.documentlist()
                  }
                })
                .catch(err => {
                  // eslint-disable-next-line
                  console.log(err)
                  this.text = 'Error put!' + err
                  this.color = 'red'
                  this.snackbar = true
                  this.timeout = 4000
                })
            }
      
      } catch (error) {
        // eslint-disable-next-line
        console.log(error)
        this.text = 'Error on save!' + error
        this.color = 'red'
        this.snackbar = true
        this.timeout = 4000
        this.error = 'Error'
      }
    },
    close () {
      this.show = false
    },
    async navigateTo (params) {
      try {                
      //const dbDocument = await DocumentService.show(params.id)
        if (params) {
          console.log('params.partnerVATID', params.partnerVATID)
          this.$store.dispatch('setDocumentActivHead', params)
        } else {
          this.$store.dispatch('setDocumentActivHead', {})
        }
        this.$store.dispatch('setDocumentid', params.id)
        this.$store.dispatch('setDatabaseDocID', params.id)
        this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
        this.mainQuery.businessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2020
        this.mainQuery.documentName = this.$store.state.documentActiv ? this.$store.state.documentActiv : null
        this.mainQuery.databaseDocID = this.$store.state.databaseDocID ? this.$store.state.databaseDocID : null
        this.docSide = this.$store.state.documentSide ? this.docSide = this.$store.state.documentSide : null

        this.items = (await DocumentDetailService.index(this.mainQuery)).data.documentDetails
        if (this.items) {
          this.$store.dispatch('setDocumentActivItems', this.items)
        } else {
          this.$store.dispatch('setDocumentActivItems', [])
        }
        this.$store.dispatch('setprintSmall', false)
        this.$store.dispatch('setprintNoPrice', false)
        this.$store.dispatch('settypePOSPrint', null)
        if (this.$store.state.documentActiv !== 'WorkingOrder') {
            this.$router.push({
            name: 'documentview'
          })
          } else {
            this.$router.push({
            name: 'documentview3'
          })
        }
        
      } catch (err) {
        // eslint-disable-next-line
        console.log('error read from database', err)
      }      
    },
    async documentlist () {
      try {
          if (this.$store.state.documentActiv !== 'WorkingOrder') {
            this.$router.push({
            name: 'document'
          })
          } else {
            this.$router.push({
            name: 'documentproduction'
          })
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(' Error ' + err)
        this.text = 'Error!' + err
        this.color = 'red'
        this.snackbar = true
        this.timeout = 4000
      }
    },
    clearPartner() {
      this.selectPa = null
      this.document.partnerId = null
      this.document.partnerName = null
      this.document.partnerNameShort = null
      this.document.partnerNameDatabase = null
      this.document.partnerBuildingNameNumber = null
      this.document.partnerStreet = null
      this.document.partnerCity = null
      this.document.partnerPostcode = null
      this.document.partnerCountyRegion = null
      this.document.partnerState = null
      this.document.partnerVATID = null
      this.document.partneremail = null
      this.document.partnerPhones = null
      this.document.partnerBankName = null
      this.document.partnerBankAddress = null
      this.document.partnerBankIBAN = null
      this.document.partnerBankSWIFT = null
      this.document.partnerContactTime = null
      this.document.partnerSecretaryTitle = null
      this.document.partnerSecretaryFirst = null
      this.document.partnerSecretaryLast = null
      this.document.partnerSecretaryEmail = null
      this.document.partnerSecretaryPhone = null
      this.document.partnerSecretaryContactOption = null
      this.document.privatePerson = false
      this.poslovnice = []
      this.selectPoslovnica = null
      this.document.SifraPoslovneJedinice = null
      this.document.NazivPoslovneJedinice = null
    },

    // Partner se ucitava na jednom mjestu. Zastavica partnerRadi zaustavlja
    // vrtnju u krug: findPartner mijenja selectPa i id u spremistu, a oba imaju
    // promatraca koji opet zovu findPartner. Kad isti OIB ima vise zapisa (u
    // bazi ih je 509, jedan OIB i 22 puta), jedan promatrac je birao zapis po
    // OIB-u, a drugi po id-u, pa su se izmjenjivali bez kraja.
    async findPartner (findQuery) {
      if (!findQuery || this.partnerRadi) { return }
      this.partnerRadi = true
      try {
      //console.log('trazim  FIND PARTNER findQuery', findQuery, 'this.findpartnerbyid  ', this.findpartnerbyid )
      //if (partnerVATID.length > 0) {
        //const locPartner = !this.findpartnerbyid ? (await PartnerService.show(findQuery)).data.partner : (await PartnerService.findbyid(findQuery)).data.partner
        const locPartner =  (await PartnerService.findbyid(findQuery)).data.partner
        this.document.partnerId = locPartner.id
        this.document.partnerName = locPartner.partnerName
        this.document.partnerNameShort = locPartner.partnerNameShort
        this.document.partnerNameDatabase = locPartner.partnerNameDatabase
        this.document.partnerBuildingNameNumber = locPartner.partnerBuildingNameNumber
        this.document.partnerStreet = locPartner.partnerStreet
        this.document.partnerCity = locPartner.partnerCity
        this.document.partnerPostcode = locPartner.partnerPostcode
        this.document.partnerCountyRegion = locPartner.partnerCountyRegion
        this.document.partnerState = locPartner.partnerState
        this.document.partnerVATID = locPartner.partnerVATID
        this.document.partneremail = locPartner.partneremail
        this.document.partnerPhones = locPartner.partnerPhones
        this.document.partnerBankName = locPartner.partnerBankName
        this.document.partnerBankAddress = locPartner.partnerBankAddress
        this.document.partnerBankIBAN = locPartner.partnerBankIBAN
        this.document.partnerBankSWIFT = locPartner.partnerBankSWIFT
        this.document.partnerContactTime = locPartner.partnerContactTime
        this.document.partnerSecretaryTitle = locPartner.partnerSecretaryTitle
        this.document.partnerSecretaryFirst = locPartner.partnerSecretaryFirst
        this.document.partnerSecretaryLast = locPartner.partnerSecretaryLast
        this.document.partnerSecretaryEmail = locPartner.partnerSecretaryEmail
        this.document.partnerSecretaryPhone = locPartner.partnerSecretaryPhone
        this.document.partnerSecretaryContactOption = locPartner.partnerSecretaryContactOption
        this.document.privatePerson = locPartner.privatePerson

        // Izbor se uvijek razrjesava po id-u - OIB nije jedinstven.
        const uPopisu = this.partners.find(partner => parseInt(partner.id) === parseInt(locPartner.id))
        if (uPopisu && this.selectPa !== uPopisu) {
          this.selectPa = uPopisu
        }
        if (parseInt(this.$store.state.partnerid) !== parseInt(locPartner.id)) {
          this.$store.dispatch('setPartnerid', locPartner.id)
        }
        await this.ucitajPoslovnice(locPartner.partnerVATID)
      } finally {
        await this.$nextTick()
        this.partnerRadi = false
      }
    },

    // Poslovne jedinice partnera iz ePoslovanja. Ako ih partner nema, izbornik
    // se ne prikazuje. Odabir se sprema u dokument (SifraPoslovneJedinice).
    // Postavke tvrtke ne mijenjaju se s ovog ekrana, pa poruka kaze gdje je uzrok.
    javiPoslovnice (poruka) {
      const kljuc = String(this.$store.state.companyid)
      if (javljenaGreska.has(kljuc)) { return }
      javljenaGreska.add(kljuc)
      const dodatak = poruka.indexOf('autentifikacij') !== -1
        ? ' Ključ za ePoslovanje ne odgovara odabranom serveru (testni/produkcijski) u postavkama tvrtke.'
        : ''
      this.text = 'Poslovne jedinice kupca nisu dohvaćene. ' + poruka + '.' + dodatak
      this.color = 'orange darken-3'
      this.timeout = 6000
      this.snackbar = true
    },
    // Poslovnice ima smisla traziti samo za izlazni racun (jedino on ide kao
    // eRacun), za pravnu osobu s hrvatskim OIB-om.
    trebaPoslovnice (vatid) {
      if (this.$store.state.documentActiv !== 'InvoiceSales') { return false }
      if (this.document.privatePerson) { return false }
      const oib = String(vatid || '').replace(/\s/g, '').replace(/^HR/i, '')
      return /^\d{11}$/.test(oib)
    },
    async ucitajPoslovnice (vatid) {
      this.poslovnice = []
      this.selectPoslovnica = null
      // Racun koji se ureduje vec moze imati upisanu jedinicu - ona ostaje
      // vidljiva i kad se popis ne moze dohvatiti.
      const upisana = this.document.SifraPoslovneJedinice
        ? {oznaka: this.document.SifraPoslovneJedinice, naziv: this.document.NazivPoslovneJedinice || ''}
        : null
      if (!this.trebaPoslovnice(vatid)) {
        if (upisana) {
          this.poslovnice = [upisana]
          this.selectPoslovnica = upisana
        }
        return
      }
      const oib = String(vatid).replace(/\s/g, '').replace(/^HR/i, '')
      const kljuc = this.$store.state.companyid + '|' + oib
      if (zapamcenePoslovnice.has(kljuc)) {
        this.poslovnice = zapamcenePoslovnice.get(kljuc)
      } else {
        this.poslovniceRadi = true
        try {
          const {data} = await EIzvjestavanjeService.poslovnice({
            CompanyId: this.$store.state.companyid,
            vatid: oib
          })
          this.poslovnice = data && data.poslovnice ? data.poslovnice : []
          if (data && data.ok === true) {
            zapamcenePoslovnice.set(kljuc, this.poslovnice)
          }
          // Tvrtka bez kljuca za ePoslovanje nije greska - tada nema ni izbornika.
          if (data && data.ok === false && data.razlog !== 'bez-kljuca') {
            this.javiPoslovnice(data.poruka || 'Poslovne jedinice nisu dohvaćene.')
          }
        } catch (err) {
          this.javiPoslovnice('Poslovne jedinice nisu dohvaćene.')
        }
        this.poslovniceRadi = false
      }
      if (upisana) {
        if (!this.poslovnice.find(p => p.oznaka === upisana.oznaka)) {
          this.poslovnice = [upisana, ...this.poslovnice]
        }
        this.selectPoslovnica = this.poslovnice.find(p => p.oznaka === upisana.oznaka)
      }
    },

    async refreshPartners() {
      await newUpdates(2)
      await testLastUpdate()
      if (this.$store.state.partnerStore) {
        this.partners = this.$store.state.partnerStore
      }
    },
    async addeditPartner () {
        if (!this.document.partnerVATID){
          this.text = this.lang.PartnerErrorVAT2
          this.color = 'red'
          this.snackbar = true
          this.timeout = 3000
          return
        }
         if (!this.document.exportDoc) {
          const partVatLeght = this.document.partnerVATID.trim().length
          if (partVatLeght !== 11) {
            this.text = this.lang.PartnerErrorVAT3
            this.color = 'red'
            this.snackbar = true
            this.timeout = 3000
            this.reqVATID = true
            return
          }
        }
        const updatePartner = {...this.document}
        this.saving = true
        if (this.document.partnerName && this.document.partnerVATID) {
          this.localError = null
          // can save as private person ONLY in document ServiceNotes and QuoteSales
          if (!this.localError) {
            this.saving = true
            // const query= {}
            const partnerId = this.document.partnerId ? this.document.partnerId : null
            const newPartner = await addUpdatePartner(updatePartner, partnerId)
            this.saving = false
            this.text = this.lang.addedPartner
            this.color = 'green'
            this.snackbar = true
            this.timeout = 2000
            await this.refreshPartners()
            console.log('vratio mi se u Documnet newPartner', newPartner)
            this.document.partnerId = newPartner.id ? newPartner.id : null
            this.selectId = newPartner.id ? parseInt(newPartner.id) : null
            this.selectPa = this.partners.find(partner => (partner.id === newPartner.id))
            this.$store.dispatch('setPartnerid', newPartner.id)
            // const findWhat = !this.document.partnerId? this.document.partnerVATID : this.document.partnerId
            // await this.findPartner(findWhat)
            // console.log('update partner', findWhat, 'this.findpartnerbyid ', this.findpartnerbyid )
            // if (findWhat) {
            //   if (this.$store.state.editItem === 0) {
            //     await this.findPartner(findWhat)
            //   }
            //   if (this.$store.state.editItem === 1 && this.document.partnerVATID !== '00000000000') {
            //     await this.findPartner(findWhat)
            //   }
            // }
            //this.selectPa = this.partners.find(partner => (partner.partnerVATID === newPartner.partner.partnerVATID))
            //await this.findPartner(newPartner.partner.partnerVATID)
          } else {
            this.text = this.localError
            this.color = 'red'
            this.snackbar = true
          }
          
        } else {
          // not enough data to save partner 
          this.text = this.lang.PartnerErrorName
          this.color = 'red'
          this.snackbar = true
          this.timeout = 4000
        } 
        
        this.saving = false
    },
    findBank (bankId) {

      if (bankId) {
        const locBank = bankId ? this.banks.find(bank => (bank.id === bankId)) : null
        this.document.bankAccountId = locBank.id ? parseInt(locBank.id) : null
        this.document.bankAccountName = locBank.BankName ? locBank.BankName : null
        this.document.bankAccountNr = locBank.IBAN ? locBank.IBAN : null
      }
      this.firstTimeBank = false
    },
    formatdocumentDate () {
     // if (this.document.documentDate) {
     //   this.document.documentDate = dayjs(this.document.documentDate).format('DD.MM.YYYY')
     // }

    },
    formatInvoiceStartDate () {
     // if (this.document.documentInvoiceStartDate) {
     //   this.document.invoiceStartDate = this.formatDate(this.document.documentInvoiceStartDate)
     // }

    },
    formatInvoiceEndDate () {
      if (this.document.documentInvoiceEndDate) {
        this.invoiceEndDate = this.localDate(this.document.documentInvoiceEndDate)
      }
    },
    formatsupplierDocumentDate () {
      if (this.document.supplierDocumentDate) {
        this.supplierDocumentDate = this.localDate(this.document.supplierDocumentDate)
      }
    },
    calculateImportDoc() {
      this.document.domecilAmount = parseNum(((this.document.exRate ? parseFloat(this.document.exRate) : 1) * (this.document.importAmount ? parseFloat(this.document.importAmount) : 0)),2)
      this.document.totalExp = (this.document.customAmount ? parseNum(this.document.customAmount, 2) : 0) + (this.document.bankExp ? parseNum(this.document.bankExp, 2) : 0) + (this.document.forwarderExp ? parseNum(this.document.forwarderExp, 2) : 0) + (this.document.transportExp ? parseNum(this.document.transportExp, 2) : 0) + (this.document.otherExp ? parseNum(this.document.otherExp, 2) : 0)
      this.document.expenesPercent = (this.document.domecilAmount && parseNum(this.document.domecilAmount, 2) > 0 ) ? (parseNum((this.document.totalExp / (parseNum(this.document.domecilAmount, 2) / 100)), 2)) : 0
      this.totalFullExp = '= ' + moneyFormat(this.document.totalExp) + ' (' + moneyFormat(this.document.expenesPercent) + '%)'
    },
    async addOpenStatement(){
      // type 1 = balance sheet, 2 = partner card,, 3 = partner open, 4 = analysis, 5= all partners open
          this.mainledgerAna.type = 5
          if (this.document.partnerId) {
            this.mainledgerAna.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 1
            this.mainledgerAna.partnerId = this.document.partnerId
            this.mainledgerAna.partnerVATID = this.document.partnerVATID
            this.mainledgerAna.BusinessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2020
            this.mainledgerAna.fromAccount = '1200'
            this.mainledgerAna.toAccount = '1200'
            this.mainledgerAna.docFromDate = dayjs([this.mainledgerAna.BusinessYear]).startOf('year').format('YYYY-MM-DD')
            this.mainledgerAna.docToDate = dayjs([this.mainledgerAna.BusinessYear]).endOf('year').format('YYYY-MM-DD')
            // eslint-disable-next-line
            console.log(' imam upit ',this.mainledgerAna)
            await MainLedgerDetailService.card(this.mainledgerAna)
            .then(res => {
              this.items = res.data.documents ? res.data.documents : []
              if (this.items.length > 0) {
                const totalOpen = round(parseNum(this.items[0].totalDebit), 2) - round(parseNum(this.items[0].totalCredit), 2)
                if (totalOpen > 0) { 
                  this.document.documentDescription5 = this.document.documentDescription5 +  'Poštovani, obaviještavam Vas da na dan izdavanja ovog dokumenta imate otvoren iznos dugovanja: ' + moneyFormat(totalOpen) + ' Kn'
                }
                if (totalOpen === 0) { 
                  this.document.documentDescription5 = this.document.documentDescription5 +  'Poštovani, obaviještavam Vas da na dan izdavanja ovog dokumenta nemate otvoren iznos dugovanja. Hvala!'
                }
                if (totalOpen < 0) { 
                  this.document.documentDescription5 = this.document.documentDescription5 +  'Poštovani, obaviještavam Vas da na dan izdavanja ovog dokumenta imate pretplatu u iznosu: ' + moneyFormat(totalOpen) + ' Kn'
                }

              } else {
                this.text = 'Error! Nema knjizenja za odabranog partnera!'
                this.color = 'red'
                this.snackbar = true
                this.timeout = 4000
              }
            })
            .catch(err => {
              this.error = this.langC.ErrorE + err
            })
          } else {
            this.text = 'Error! Partner nije definiran!'
            this.color = 'red'
            this.snackbar = true
            this.timeout = 4000
          }
    }
  },
  watch: {
    'document.exculdeEmail'(){
      if (this.document.exculdeEmail) {
        this.document.partneremail = '.'
      }
      if (!this.document.exculdeEmail) {
        this.document.partneremail = null
      }
    },  
    'nrDays' () {
      if (!this.nrDays) {
        this.nrDays = 15
      }
      if (this.nrDays > 999) {
        this.nrDays = 15
      }
      this.document.documentInvoiceEndDate = dayjs(new Date(this.document.documentDate)).add(this.nrDays, 'days').format('YYYY-MM-DD')
    },
    'myPartnerid' () {
      if (this.partnerRadi) { return }
      if (this.$store.state.partnerid) {
        if (parseInt(this.$store.state.partnerid) === parseInt(this.document.partnerId)) { return }
        this.findpartnerbyid = true
        //this.selectPa = this.$store.state.partnerid ? this.partners.find(partner => (partner.id === this.$store.state.partnerid)) : null
        this.findPartner(this.$store.state.partnerid)
        this.showPartners = false
      }
     // this.partner()
    },
    'documentFrom' () {
      if (this.$store.state.documentFrom) {
        console.log('this.$store.state.documentFrom', this.$store.state.documentFrom)
        const nrInv = this.$store.state.documentFrom && this.$store.state.documentFrom.documentId ? this.$store.state.documentFrom.documentId : null
        this.document.RefNaPrethodniRacun = nrInv + '/' + this.$store.state.companyActiv.CompanyBusinessSpaceRetail + '/' + this.$store.state.companyActiv.CompanyBusinessDeviceRetail
        this.document.RefNaPrethodniRacunDatum = this.$store.state.documentFrom && this.$store.state.documentFrom.documentDate ? this.$store.state.documentFrom.documentDate : null
        this.cardSales()
      }
    },
    'selectPa' (val) {
      if (this.partnerRadi) { return }
      if (val) {
        if (parseInt(val.id) === parseInt(this.document.partnerId)) { return }
        this.findPartner(val.id)

        // if (findWhat) {
        //   if (this.$store.state.editItem === 0) {
        //     this.findPartner(findWhat)
        //   }
        //   if (this.$store.state.editItem === 1 && val.partnerVATID !== '00000000000') {
        //     this.findPartner(findWhat)
        //   }
        // }
      }
      if (!val) {
        this.clearPartner()
      }
    },
    'selectPoslovnica' (val) {
      this.document.SifraPoslovneJedinice = val && val.oznaka ? val.oznaka : null
      this.document.NazivPoslovneJedinice = val && val.naziv ? val.naziv : null
    },
    'selectBank' (val) {
      if (val) {
        val.id && this.findBank(val.id) 
      }           
    },
    'selectPT' (val) {
      if (val) {
        this.document.productiontype = val.value ? val.value : null
      }           
    },
    'selectDS' (val) {
      if (val) {
        this.document.docColor = val.docColor ? val.docColor : ''
        this.document.docStatus = val.docStatus ? val.docStatus : ''
      } else {
        this.document.docColor = null
        this.document.docStatus = null
      }
    },
    'selectpospro' (val) {
      if (val) {
        this.document.eRacunPoslovniProces = val.text ? val.text : ''
        this.document.eRacunPoslovniProcesSifra = val.value ? val.value : 'P1'
      } else {
        this.document.eRacunPoslovniProces = null
        this.document.eRacunPoslovniProcesSifra = null
      }
    },
    'selecttipdok' (val) {
      if (val) {
        this.document.TipDokumenta = val.text ? val.text : ''
        this.document.TipDokumentaBroj = val.value ? val.value : 'P1'
      } else {
        this.document.TipDokumenta = null
        this.document.TipDokumentaBroj = null
      }
    },
    'selectDD' (val) {
      if (val) {
        this.document.documentDescription5 = val.description ? this.document.documentDescription5 + val.description : ''
      }
    },
    // 'document.documentDate' () {
    //   this.formatdocumentDate()
    // },
    // 'document.documentInvoiceStartDate' () {
    //   this.formatInvoiceStartDate()
    // },
    // 'document.documentInvoiceEndDate' () {
    //   this.formatInvoiceEndDate()
    // },
    'document.supplierDocumentDate' () {
      this.formatsupplierDocumentDate()
    },
    'document.documentTotalAmountPayInAdvance' () {
      if (isNaN(this.document.documentTotalAmountPayInAdvance)) {
        this.document.documentTotalAmountPayInAdvance = 0
      }
      if (!this.document.documentTotalAmountPayInAdvance) {
        this.document.documentTotalAmountPayInAdvance
      }
      const exRate = this.document.documentExRate ? this.document.documentExRate : 1
      this.document.documentTotalAmountPayInAdvance = round(this.document.documentTotalAmountPayInAdvance, 2)
      this.document.documentTotalAmountToPay = this.document.documentTotalAmountBrutto ? (round(this.document.documentTotalAmountBrutto, 2) - (this.document.documentTotalAmountPayInAdvance)): 0
      this.document.documentTotalAmountPayInAdvanceForeign = round((this.document.documentTotalAmountPayInAdvance / exRate), 2)
      this.document.documentTotalAmountToPayForeign = this.document.documentTotalAmountBrutto ? (round((this.document.documentTotalAmountBrutto/ exRate), 2) - (this.document.documentTotalAmountPayInAdvance / exRate) ) : 0  
    },
    'document.importAmount' () {
      if (!this.document.importAmount) {
        this.document.importAmount  = 0
      }
      if (this.document.importAmount && this.document.exportDoc) {
        this.calculateImportDoc()
      }
    },
    'document.exRate' () {
      if (!this.document.exRate) {
        this.document.exRate  = 0
      }
      if (this.document.exRate && this.document.exportDoc) {
        this.calculateImportDoc()
      }
    },
    'document.customAmount' () {
      if (!this.document.customAmount) {
        this.document.customAmount  = 0
      }
      if (this.document.customAmount && this.document.exportDoc) {
        this.calculateImportDoc()
      }
    },
    'document.bankExp' () {
      if (!this.document.bankExp) {
        this.document.bankExp  = 0
      }
      if (this.document.bankExp && this.document.exportDoc) {
        this.calculateImportDoc()
      }
    },
    'document.forwarderExp' () {
      if (!this.document.forwarderExp) {
        this.document.forwarderExp  = 0
      }
      if (this.document.forwarderExp && this.document.exportDoc) {
        this.calculateImportDoc()
      }
    },
    'document.transportExp' () {
      if (!this.document.transportExp) {
        this.document.transportExp  = 0
      }
      if (this.document.transportExp && this.document.exportDoc) {
        this.calculateImportDoc()
      }
    },
    'document.otherExp' () {
      if (!this.document.otherExp) {
        this.document.otherExp  = 0
      }
      if (this.document.otherExp && this.document.exportDoc) {
        this.calculateImportDoc()
      }
    },
    'document.exportDoc' () {
      this.importPurchase = false
      if (this.have6) {
        if (this.document.exportDoc) {
          this.importPurchase = true
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Zajednicki stil obrazaca je u src/assets/forma.css (klasa "forma-erp"). */

/* Naslovna traka koja uz naziv nosi i padajuce izbornike (kartica Servis). */
.naslov-s-poljima {
  gap: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
}
.polje-u-naslovu {
  max-width: 220px;
  min-width: 170px;
  flex: 1 1 170px;
}

/* Kvacice "Ino" i "PPO" stoje jedna uz drugu, desno od polja u istom redu. */
.kvacice-uvjeti {
  display: flex;
  align-items: center;
  gap: 22px;
  flex-wrap: wrap;
}
</style>
